import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Evie Outdoors</h3>
            <p className="text-gray-300 mb-4">Premium Outdoor Structures for Modern Living</p>
            <p className="text-gray-300">
              Serving Ontario with luxury outdoor living solutions that stand the test of time.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="/pergolas" className="hover:text-white">
                  Pergolas
                </a>
              </li>
              <li>
                <a href="/awnings" className="hover:text-white">
                  Awnings
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-white">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div className="text-center">
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="flex items-center justify-center mb-2">
              <span className="mr-2 text-red-500">🍁</span>
              <p className="text-gray-300">Located in Toronto, ON</p>
            </div>
            <div className="bg-accent/20 text-accent px-3 py-2 rounded-lg mb-4 inline-block">
              <p className="text-sm font-semibold">🏢 Toronto Area Showroom Coming Soon!</p>
            </div>
            <div className="space-y-2 mb-4">
              <div className="flex items-center justify-center">
                <span className="mr-2">📞</span>
                <div>
                  <p className="text-gray-300">Local: <a href="tel:+19056745983" className="hover:text-white">(905) 674-5983</a></p>
                  <p className="text-gray-300">Toll Free: <a href="tel:+18554744653" className="hover:text-white">(855) 474-4653</a></p>
                </div>
              </div>
              <div className="flex items-center justify-center">
                <span className="mr-2">✉️</span>
                <p className="text-gray-300">hello@evieoutdoors.com</p>
              </div>
            </div>
            <a
              href="https://calendly.com/evieoutdoors/free-outdoor-living-consultation"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-accent text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors inline-block"
            >
              Schedule Consultation
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>© 2025 Evie Outdoors. All rights reserved.</p>
          <p className="text-sm mt-2">Owned and Operated by Powerplay Systems Inc</p>
          <div className="mt-4">
            <a href="/privacy-policy" className="text-gray-400 hover:text-white text-sm underline">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
